import { render } from "./layout.vue?vue&type=template&id=6d0438ca&scoped=true"
import script from "./layout.vue?vue&type=script&lang=js"
export * from "./layout.vue?vue&type=script&lang=js"

import "./layout.vue?vue&type=style&index=0&id=6d0438ca&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-6d0438ca"

export default script